import { ApiRequestError } from "./apiRequestError";

export type StatisticsFetchError = {
  message: string;
  action?: string;
  slug?: string;
  status?: number;
};

export const STATISTICS_FETCH_ERROR_EVENT = "statistics:fetch-error";

export type StatisticsFetchErrorEventDetail = {
  key: string;
  error: StatisticsFetchError | null;
};

export function normalizeStatisticsFetchError(
  err: unknown,
  fallback: string
): StatisticsFetchError {
  if (err instanceof ApiRequestError) {
    return {
      message: err.message,
      action: err.action,
      slug: err.slug,
      status: err.status,
    };
  }
  if (err instanceof Error && err.message.trim()) {
    return { message: err.message.trim() };
  }
  return { message: fallback };
}

export function dispatchStatisticsFetchError(
  key: string,
  error: StatisticsFetchError | null
): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<StatisticsFetchErrorEventDetail>(STATISTICS_FETCH_ERROR_EVENT, {
      detail: { key, error },
    })
  );
}
